import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,

  hashbang: false,
  history: true,
  linkActiveClass: "active",
  root:  'index.html',

  routes: [
    {
      path: '/',
      name: 'main',
      component: () => import('./pages/Main')
    },
    {
      path: '/resume/',
      name: 'resume',
      component: () => import('./pages/Resume'),
      meta: {
        title: 'Резюме',
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Резюме', link: '' }
        ]
      }
    },
    {
      path: '/portfolio/',
      name: 'portfolio',
      component: () => import('./pages/Portfolio'),
      meta: {
        title: 'Портфолио',
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Портфолио', link: '' }
        ]
      }
    },
    {
      path: '/links/',
      name: 'links',
      component: () => import('./pages/Links'),
      meta: {
        title: 'Полезные ссылки',
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Полезные ссылки', link: '' }
        ]
      }
    },
    {
      path: '/contacts/',
      name: 'contacts',
      component: () => import('./pages/Contacts'),
      meta: {
        title: 'Контакты',
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Контакты', link: '' }
        ]
      }
    },
    {
      path: '/photos/',
      name: 'photos',
      component: () => import('./pages/Photos'),
      meta: {
        title: 'Фотогалерея',
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Фотогалерея', link: '' }
        ]
      }
    },
    {
      path: '/tests/',
      name: 'tests',
      component: () => import('./pages/Tests'),
      meta: {
        title: 'Тестовые задания',
        breadcrumb: [
          { name: 'Главная', link: '/' },
          { name: 'Тестовые задания', link: '' }
        ]
      },
      children: [
        {
          path: 'domRF/',
          component: () => import('./pages/tests/domRF'),
          title: 'Тестовое задание от Дом.РФ'
        },
        {
          path: 'mediapronet',
          component: () => import('./pages/tests/mediapronet'),
          title: 'Тестовое задание от Mediapronet'
        },
        {
          path: 'klerk',
          component: () => import('./pages/tests/klerk'),
          title: 'Тестовое задание от Klerk'
        },
        {
          path: 'tkb',
          component: () => import('./pages/tests/tkb'),
          title: 'Тестовое задание от Транскапиталбанк'
        },
        {
          path: 'dreamte',
          component: () => import('./pages/tests/dreamte'),
          title: 'Тестовое задание от Дрим Тим'
        },
        {
          path: 'smile-tech',
          component: () => import('./pages/tests/smile-tech'),
          title: 'Тестовое задание от Smail Tech'
        },
        {
          path: 'ekodar',
          component: () => import('./pages/tests/ekodar'),
          title: 'Тестовое задание от Экодар'
        },
        {
          path: 'rda',
          component: () => import('./pages/tests/rda'),
          title: 'Тестовое задание от ИП Рудова Д.А.'
        },
        {
          path: 'profit',
          component: () => import('./pages/tests/profit'),
          title: 'Тестовое задание от PROFIT agency'
        }
      ]
    },
    {
      path: '/library/',
      name: 'library',
      component: () => import('./pages/Library'),
      meta: {
        title: 'Библиотека / Архив',
        breadcrumb: [
          {name: 'Главная', link: '/'},
          {name: 'Библиотека / Архив', link: ''}
        ]
      }
    },
    {
      path: '/404/',
      name: '404',
      component: () => import('./pages/404'),
      meta: {
        title: 'Странцица не найдена'
      }
    },
    {
      path: '*',
      redirect: '/404/'
    },
  ]
});

const DEFAULT_TITLE = 'Кандинский Николай - персональный сайт';

router.afterEach((to) => {
  document.title = to.meta.title ? 'Кандинский Николай - ' + to.meta.title : DEFAULT_TITLE;
});

export default router;